import {HttpLink} from "apollo-link-http";
import fetch from "node-fetch";
import {ApolloClient} from 'apollo-client'
import {InMemoryCache} from "apollo-cache-inmemory";


let uri = 'http://localhost:5000/';

if (process.env.NODE_ENV === 'production') {
  uri = '/graphql'
}

if (process.env.VUE_APP_API_URL) {
  uri = process.env.VUE_APP_API_URL
}

if (process.env.SERVER && process.env.SERVER_API_URL) {
  uri = process.env.SERVER_API_URL
}

const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri,
  fetch: fetch
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache({
    // addTypename: false
  })
});

export {
  apolloClient
}

export default ({router, state}) => {
  return apolloClient;
}
